import en from "./locales/en.json";

export interface Labels {
  home_manifestation: string;
  input_instructions_placeholder: string;
  input_instructions_search: string;
  workspace_empty_instructions: string;
}

type Languages = "en";

const labelsByLanguage: Record<Languages, Labels> = {
  en: en,
};

export function label(key: keyof Labels, language: Languages = "en"): string {
  return labelsByLanguage[language][key];
}
